import { useMediaQuery } from "@mui/material";
import React, { HTMLAttributes } from "react";
import { theme } from "@/theme";
import { Card } from "@/components/Card";
import { Address } from "./types";
import { CardActions } from "@/components/Card/CardActions";
import { getDisplayDate } from "./helpers";

export type BoxCardProps = {
  shipDate?: Date;
  address: Address;
  status?: string;
  endChildren?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  onAddProduct?: () => void;
} & HTMLAttributes<HTMLElement>;

export const BoxCard = ({
  shipDate,
  address,
  status,
  endChildren,
  children,
  actions,
  onAddProduct,
  ...attrs
}: BoxCardProps) => {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const {
    firstName,
    lastName,
    company,
    address1,
    address2,
    city,
    province,
    zip,
  } = address;

  const shipsOn = (
    <div className="shrink-0 md:flex md:w-32 md:flex-col md:justify-center lg:w-36">
      <p className="body">{shipDate ? "Ships On:" : "Status:"}</p>
      <h5 className="body text-xl font-semibold text-primary">
        {status
          ? status
          : shipDate
          ? getDisplayDate(shipDate, {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          : "Cancelled"}
      </h5>
    </div>
  );

  const addrDisplay = (
    <div className="md:flex md:flex-col md:justify-center">
      <p className="body text-sm">
        <span className="font-semibold">
          {(firstName || lastName) && `${firstName} ${lastName}`}
          {company && `, ${company}`}
        </span>
        <br />
        {address1}
        {address2 && <span>, {address2}</span>}
        <span className="hidden sm:inline">,&nbsp;</span>
        <br className="sm:hidden" />
        {city}, {province} {zip}
      </p>
    </div>
  );

  return (
    <Card
      bordered={false}
      className="max-w-full shadow"
      actions={<CardActions orientation="responsive">{actions}</CardActions>}
      {...attrs}
    >
      <div className="md:space-y-4">
        <div className="w-full space-y-4 md:flex md:space-x-4 md:space-y-0 lg:space-x-10">
          {shipsOn}
          <hr className="divider-x md:divider-y my-4 md:mx-4 md:my-0 md:h-20" />
          {addrDisplay}
          {isMobile && children}
          {endChildren ? (
            <div className="md:flex md:grow md:justify-end">{endChildren}</div>
          ) : null}
        </div>
        {!isMobile && children}
      </div>
    </Card>
  );
};
